/**
  Description:
  formats date depending on what format is passed,
  if there is no date returns "-""
**/

import moment from 'moment'

export default {
  filters: {
    date (date, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!(date === null)) {
        return moment.utc(date).format(format)
      } else {
        return '-'
      }
    }
  }
}
